import { BNBox, BNJumpToNavigation, BNLogo } from "@bn-monorepo/js-packages";

import BNLink from "../BnComponents/BNLink/BNLink";
import React, { useContext } from "react";
import { useTheme } from "@mui/material/styles";
import { SettingsContext } from "../../settingsContext";

interface Props {
  isSticky: boolean;
  transparentBg: boolean;
  homeLink: string;
}

const BNHeaderLogoOnly: React.FC<Props> = ({ isSticky, transparentBg, homeLink }) => {
  const theme = useTheme();
  const { isApp, localization } = useContext(SettingsContext);
  const stickySx = isSticky
    ? {
        position: "sticky",
        top: "0",
        zIndex: 2,
      }
    : {};
  return (
    <>
      <BNJumpToNavigation jumpToNavigationString={localization?.jumpToNavigation} />
      <BNBox
        component={"header"}
        sx={{
          ...stickySx,
          width: "100%",
          backgroundColor: isApp || transparentBg ? "background.default" : "tertiary.dark",
          borderBottom: transparentBg && !isApp ? `0.1rem solid ${theme.vars.palette.divider}` : "",
          display: "block",
          alignItems: "center",
          [theme.breakpoints.up("sm")]: {
            py: 1,
            px: 3,
          },
          [theme.breakpoints.up("md")]: {
            height: "6rem",
            padding: "0 1rem",
          },
        }}
      >
        <BNBox
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 1,
          }}
        >
          <BNLink href={homeLink} isSpa={true}>
            <BNLogo dark={isApp || transparentBg} />
          </BNLink>
        </BNBox>
      </BNBox>
    </>
  );
};

export default BNHeaderLogoOnly;
